"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getTokenItemId = exports.default = void 0;
var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _icons = require("@ant-design/icons");
var _antd = require("antd");
var _classnames = _interopRequireDefault(require("classnames"));
var _react = _interopRequireWildcard(require("react"));
var _ColorPreview = _interopRequireDefault(require("../../ColorPreview"));
var _icons2 = require("../../icons");
var _TokenInput = _interopRequireDefault(require("../../TokenInput"));
var _getValueByPath3 = _interopRequireDefault(require("../../utils/getValueByPath"));
var _isColor = _interopRequireDefault(require("../../utils/isColor"));
var _makeStyle = _interopRequireDefault(require("../../utils/makeStyle"));
var _statistic = require("../../utils/statistic");
var _excluded = ["info", "visible", "tokenName", "style", "dark"];
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var Panel = _antd.Collapse.Panel;
var AdditionInfo = function AdditionInfo(_ref) {
  var info = _ref.info,
    visible = _ref.visible,
    tokenName = _ref.tokenName,
    style = _ref.style,
    dark = _ref.dark,
    rest = (0, _objectWithoutProperties2.default)(_ref, _excluded);
  if (typeof info === 'string' && (0, _isColor.default)(info)) {
    return /*#__PURE__*/_react.default.createElement(_ColorPreview.default, {
      dark: dark,
      color: String(info),
      style: _objectSpread({
        display: visible ? 'block' : 'none'
      }, style)
    });
  }
  if (info.toString().length < 6 && String(info) !== '') {
    return /*#__PURE__*/_react.default.createElement("div", (0, _extends2.default)({
      style: _objectSpread({
        height: 20,
        overflow: 'hidden',
        backgroundColor: 'rgba(0,0,0,0.04)',
        borderRadius: '8px',
        display: visible ? 'block' : 'none',
        padding: '0 6px',
        lineHeight: '20px'
      }, style)
    }, rest), info);
  }
  return null;
};
var ShowUsageButton = function ShowUsageButton(_ref2) {
  var selected = _ref2.selected,
    toggleSelected = _ref2.toggleSelected;
  return /*#__PURE__*/_react.default.createElement(_icons2.Pick, {
    style: {
      color: selected ? '#1890ff' : undefined,
      cursor: 'pointer',
      fontSize: 16,
      transition: 'color 0.3s',
      marginInlineStart: 12,
      verticalAlign: 'middle'
    },
    onClick: function onClick() {
      return toggleSelected(!selected);
    }
  });
};
var useStyle = (0, _makeStyle.default)('TokenItem', function (token) {
  return (0, _defineProperty2.default)({}, "".concat(token.rootCls, "-collapse.previewer-token-item-collapse"), (0, _defineProperty2.default)({}, ".previewer-token-item".concat(token.rootCls, "-collapse-item"), (0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)({
    transition: "background-color ".concat(token.motionDurationSlow),
    borderRadius: {
      _skip_check_: true,
      value: "4px !important"
    }
  }, "&:not(".concat(token.rootCls, "-collapse-item-active):hover"), {
    backgroundColor: '#f5f5f5'
  }), "> ".concat(token.rootCls, "-collapse-header"), {
    padding: '12px 8px'
  }), "".concat(token.rootCls, "-collapse-header-text"), {
    flex: 1,
    width: 0
  }), "".concat(token.rootCls, "-collapse-content-box"), {
    padding: '0 4px'
  }), "".concat(token.rootCls, "-collapse-expand-icon"), {
    paddingInlineEnd: "".concat(token.paddingXXS, "px !important")
  }), '.previewer-token-count', {
    height: 16,
    fontSize: token.fontSizeSM,
    lineHeight: '16px',
    borderRadius: 100,
    paddingInline: token.paddingXXS * 1.5,
    color: token.colorTextSecondary,
    backgroundColor: token.colorFillAlter
  }), '.previewer-token-item-name', {
    transition: 'color 0.3s'
  }), '.previewer-token-item-highlighted.previewer-token-item-name', {
    color: "".concat(token.colorPrimary, " !important")
  }), '&:hover .previewer-token-preview', {
    '> .previewer-color-preview:not(:last-child)': {
      transform: 'translateX(-100%)',
      marginInlineEnd: 4
    }
  }), '.previewer-token-preview', {
    display: 'flex',
    alignItems: 'center',
    position: 'relative',
    '> .previewer-color-preview': {
      position: 'absolute',
      insetInlineEnd: 0,
      top: 0,
      bottom: 0,
      margin: 'auto'
    },
    '> .previewer-color-preview:not(:last-child)': {
      transform: 'translateX(-50%)',
      marginInlineEnd: 0,
      transition: 'transform 0.3s, margin-right 0.3s'
    },
    '> *:not(:last-child)': {
      marginInlineEnd: 4
    }
  })));
});
var getTokenItemId = exports.getTokenItemId = function getTokenItemId(token) {
  return "previewer-token-panel-item-".concat(token);
};
var _default = exports.default = function _default(_ref4) {
  var tokenName = _ref4.tokenName,
    active = _ref4.active,
    onActiveChange = _ref4.onActiveChange,
    onTokenChange = _ref4.onTokenChange,
    tokenPath = _ref4.tokenPath,
    selectedTokens = _ref4.selectedTokens,
    themes = _ref4.themes,
    onTokenSelect = _ref4.onTokenSelect,
    enableTokenSelect = _ref4.enableTokenSelect,
    hideUsageCount = _ref4.hideUsageCount,
    fallback = _ref4.fallback;
  var _React$useState = _react.default.useState(false),
    _React$useState2 = (0, _slicedToArray2.default)(_React$useState, 2),
    infoVisible = _React$useState2[0],
    setInfoVisible = _React$useState2[1];
  var _useStyle = useStyle(),
    _useStyle2 = (0, _slicedToArray2.default)(_useStyle, 2),
    wrapSSR = _useStyle2[0],
    hashId = _useStyle2[1];
  (0, _react.useEffect)(function () {
    if (active) {
      setInfoVisible(true);
    }
  }, [active]);
  var handleTokenChange = function handleTokenChange(theme, value) {
    onTokenChange === null || onTokenChange === void 0 || onTokenChange(theme, tokenName, value);
  };
  var count = (0, _react.useMemo)(function () {
    return (0, _statistic.getRelatedComponents)(tokenName).length;
  }, [tokenName]);
  return wrapSSR( /*#__PURE__*/_react.default.createElement("div", {
    onMouseEnter: function onMouseEnter() {
      return onActiveChange === null || onActiveChange === void 0 ? void 0 : onActiveChange(false);
    }
  }, /*#__PURE__*/_react.default.createElement(_antd.Collapse, {
    collapsible: "header",
    ghost: true,
    onChange: function onChange(key) {
      return setInfoVisible(key.length > 0);
    },
    className: (0, _classnames.default)('previewer-token-item-collapse', hashId),
    expandIcon: function expandIcon(_ref5) {
      var isActive = _ref5.isActive;
      return /*#__PURE__*/_react.default.createElement(_icons.CaretRightOutlined, {
        rotate: isActive ? 90 : 0,
        style: {
          fontSize: 12,
          cursor: 'pointer'
        }
      });
    },
    activeKey: infoVisible ? tokenName : undefined
  }, /*#__PURE__*/_react.default.createElement(Panel, {
    key: tokenName,
    className: "previewer-token-item",
    header: /*#__PURE__*/_react.default.createElement("div", {
      style: {
        display: 'flex',
        alignItems: 'center',
        gap: 8
      },
      id: getTokenItemId(tokenName)
    }, /*#__PURE__*/_react.default.createElement("span", {
      style: {
        flex: 1,
        width: 0,
        display: 'flex',
        overflow: 'hidden',
        alignItems: 'center'
      }
    }, /*#__PURE__*/_react.default.createElement("span", {
      title: tokenName,
      className: (0, _classnames.default)('previewer-token-item-name', {
        'previewer-token-item-highlighted': active
      }),
      style: {
        marginInlineEnd: '5px',
        overflow: 'hidden',
        textOverflow: 'ellipsis'
      }
    }, tokenName), !hideUsageCount && /*#__PURE__*/_react.default.createElement("span", {
      className: "previewer-token-count"
    }, count)), !infoVisible && /*#__PURE__*/_react.default.createElement("div", {
      className: "previewer-token-preview",
      style: {
        minWidth: themes.length * 20 + (themes.length - 1) * 4
      }
    }, themes.map(function (_ref6, index) {
      var _ref7, _getValueByPath;
      var config = _ref6.config,
        key = _ref6.key;
      return /*#__PURE__*/_react.default.createElement(AdditionInfo, {
        key: key,
        dark: key === 'dark',
        tokenName: tokenName,
        info: (_ref7 = (_getValueByPath = (0, _getValueByPath3.default)(config, [].concat((0, _toConsumableArray2.default)(tokenPath), [tokenName]))) !== null && _getValueByPath !== void 0 ? _getValueByPath : fallback === null || fallback === void 0 ? void 0 : fallback(config)[tokenName]) !== null && _ref7 !== void 0 ? _ref7 : '',
        visible: !infoVisible,
        style: {
          zIndex: 10 - index
        }
      });
    }))),
    extra: enableTokenSelect ? /*#__PURE__*/_react.default.createElement(ShowUsageButton, {
      selected: !!(selectedTokens !== null && selectedTokens !== void 0 && selectedTokens.includes(tokenName)),
      toggleSelected: function toggleSelected() {
        onTokenSelect === null || onTokenSelect === void 0 || onTokenSelect(tokenName);
      }
    }) : undefined
  }, /*#__PURE__*/_react.default.createElement(_antd.Space, {
    direction: "vertical",
    style: {
      background: '#fafafa',
      borderRadius: 4,
      padding: 8,
      width: '100%'
    }
  }, themes.map(function (theme) {
    var _getValueByPath2;
    return /*#__PURE__*/_react.default.createElement("div", {
      key: theme.key
    }, /*#__PURE__*/_react.default.createElement(_TokenInput.default, {
      hideTheme: themes.length === 1,
      theme: theme,
      onChange: function onChange(value) {
        return handleTokenChange(theme, value);
      },
      value: (_getValueByPath2 = (0, _getValueByPath3.default)(theme.config, [].concat((0, _toConsumableArray2.default)(tokenPath), [tokenName]))) !== null && _getValueByPath2 !== void 0 ? _getValueByPath2 : fallback === null || fallback === void 0 ? void 0 : fallback(theme.config)[tokenName]
    }));
  }))))));
};